module.exports = __webpack_public_path__ + "static/img/search.618a4ee3.svg";